import Component from '@bythepixel/component-loader';
import { add } from 'cart-localstorage';

export default class AddToCart extends Component {
  static selector = '[comp-add-to-cart]';

  constructor(...args) {
    super(...args);
    this.productData = this.$container.dataset;
    this.addToCartButton = this.$container.querySelector('[data-add-to-cart-button]');
    this.quantityInput = this.$container.querySelector('[quantity-input]');
    this.addedSuccessMessage = this.$container.querySelector('[data-added-success]');
    this.events();
  }

  events() {
    this.addToCartButton.addEventListener('click', (e) => {
      e.preventDefault();

      add({
        id: this.productData.productId,
        name: this.productData.title,
        price: this.productData.price,
        variantTitle: this.productData.variantTitle,
        imageSrc: this.productData.imageSrc,
        imageAlt: this.productData.imageAlt,
      }, parseInt(this.quantityInput?.value, 10) || 1);

      this.showSuccessMessage();
      updateCartIcon();
    });
  }

  showSuccessMessage() {
    this.addedSuccessMessage.classList.remove('invisible');
    this.addedSuccessMessage.classList.add('opacity-100');
    this.disableCartButton();

    setTimeout(() => {
      this.hideSuccessMessage();
    }, 5000);
  }

  hideSuccessMessage() {
    this.addedSuccessMessage.classList.add('invisible');
    this.addedSuccessMessage.classList.remove('opacity-100');
    this.enableCartButton();
  }

  disableCartButton() {
    this.addToCartButton.classList.add('btn--disabled');
    this.addToCartButton.setAttribute('disabled', true);
  }

  enableCartButton() {
    this.addToCartButton.classList.remove('btn--disabled');
    this.addToCartButton.removeAttribute('disabled');
  }
}

function updateCartIcon() {
  if (window?.CIMARRON?.cartIcons) {
    window.CIMARRON.cartIcons.forEach((cartIcon) => {
      cartIcon.renderCartIcon();
    });
  }
}
